module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/odkbav/tc-custom/9781449461362.jpg?1708400178173",
      "alt": "This image is the cover for the book Serenity Prayers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Serenity Prayers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Serenity Prayers")]), _vm._v(" is a lovely and timeless collection of prayers, prose, and poems that leaves readers feeling relaxed, peaceful, hopeful, and encouraged. It's a thoughtful resource for facing everyday challenges."), _c('br'), _c('br'), _vm._v(" Excerpt from the book:"), _c('br'), _vm._v(" \"A Clear Midnight"), _c('br'), _vm._v(" This is thy hour O Soul, thy free flight into the wordless,"), _c('br'), _vm._v(" Away from books, away from art, the day erased, the lesson done,"), _c('br'), _vm._v(" Thee fully forth emerging, silent, gazing, pondering the themes thou lovest best,"), _c('br'), _vm._v(" Night, sleep, death and the stars.\""), _c('br'), _vm._v(" --Walt Whitman (1819-1892)"), _c('br'), _c('br'), _vm._v(" Features selections from Mitch Albom, Emily Dickinson, William Penn, Rumi, Carl Sandburg, Henry David Thoreau, Walt Whitman, and William Butler Yeats.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      June Cotner\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0